import { overrideTestIds } from "../../../utils/TestIds/overrideTestIds";
import { pathgen } from 'object-path-generator';
export const TextFieldTestIds = pathgen('TextFieldTestIds', overrideTestIds({
  TextFieldTestIds: {
    root: testid => testid,
    input: testid => testid && "".concat(testid, "-input"),
    label: testid => testid && "".concat(testid, "-label"),
    placeholder: testid => testid && "".concat(testid, "-placeholder"),
    backdrop: testid => testid && "".concat(testid, "-backdrop"),
    helperText: testid => testid && "".concat(testid, "-helper-text")
  }
}));